interface ResolveVisibleTeamListParams<TTeam extends { id: string }> {
  activeTeamList: readonly TTeam[];
  teamList: readonly TTeam[];
  teamId?: string;
  canManageWorkspace: boolean;
}

export function resolveVisibleTeamList<TTeam extends { id: string }>({
  activeTeamList,
  teamList,
  teamId,
  canManageWorkspace,
}: ResolveVisibleTeamListParams<TTeam>): readonly TTeam[] {
  if (!canManageWorkspace || !teamId) {
    return activeTeamList;
  }

  if (activeTeamList.some((team) => team.id === teamId)) {
    return activeTeamList;
  }

  const viewedTeam = teamList.find((team) => team.id === teamId);
  if (!viewedTeam) {
    return activeTeamList;
  }

  return [...activeTeamList, viewedTeam];
}
